namespace Gamification.Gamification {
    export namespace UtentiProdottiAlertService {
        export const baseUrl = 'Gamification/UtentiProdottiAlert';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiAlertRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiAlertRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiAlertRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiAlertRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiAlert/Create",
            Update = "Gamification/UtentiProdottiAlert/Update",
            Delete = "Gamification/UtentiProdottiAlert/Delete",
            Retrieve = "Gamification/UtentiProdottiAlert/Retrieve",
            List = "Gamification/UtentiProdottiAlert/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiAlertService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
